import { createAction, props } from '@ngrx/store';
import { OdataEquipmentsModel } from '../../interfaces/equipments-odata.interface';
import { InterimModel } from '../../interfaces/interim.interface';

export const getEquipmentsWithMatSer = createAction(
    '[Protocols] get Equipments with mat/ser',
    props<{ materialNumber: string; serialNumber: string }>(),
);

export const getEquipmentsWithOrder = createAction(
    '[Protocols] get Equipments with order number',
    props<{ orderNumber: string }>(),
);

export const getEquipmentsSuccess = createAction(
    '[Protocols] get Equipments Success',
    props<{ protocols: OdataEquipmentsModel }>(),
);

export const getEquipmentsError = createAction('[Protocols] get Equipments Error', props<{ error: unknown }>());

export const navigateToForms = createAction('[Protocols] Navigate to Forms', props<{ orderNumber: string }>());

export const navigateToProtocols = createAction('[Forms list] Navigate to Protocols');

export const showEquipmentsListModal = createAction('[Protocols] Show Equipments list modal');

export const showNoEquipmentsAvailableModal = createAction('[Protocols] Show no equipments modal');

export const showInterimsLimitModal = createAction(
    '[Protocols] Show interims limit modal',
    props<{ interims: InterimModel[] }>(),
);
